import React, { useState, useEffect } from "react";
import {
  FaBoxOpen, FaMoneyBillWave, FaTags, FaFileAlt, FaListUl, FaUser, FaPhone, FaEnvelope, FaBuilding, FaMapMarkerAlt, FaFileInvoice, FaImage, FaIdCard, FaFilePdf, FaSearch, FaPlus, FaTimes
} from "react-icons/fa";

import axios from 'axios'
import toast from "react-hot-toast";
import Select from 'react-select';
import { Button, Card } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import { useRef } from "react";


function Pincode({ token }) {

  const [showForm, setShowForm] = useState(false);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [pincode, setPincode] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDelete, setSelectedDelete] = useState(null);
  const [file, setFile] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const fileInputRef = useRef(null);
  const [selectedState, setSelectedState] = useState("");
const [selectedCity, setSelectedCity] = useState("");

  const [formData, setFormData] = useState({
    state: '',
    city: '',
    pincode: '',
    region: '',
  });


  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "profile") {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleFileChange = async (e) => {

    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    setFile(selectedFile);


    await handleBulkUpload(selectedFile);
    e.target.value = null;
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        "https://api.krimotion.in/add-master-pincode",
        {
          pincode: formData.pincode,
          city: formData.city,
          state: formData.state,

        },
          {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );


      setShowForm(false);
      toast.success('Pincode And City Added successfully!');
      fetchMasterPincode();
     resetForm();
    } catch (err) {
      const message = err.response?.data?.message;

      if (message === "Pincode already exists") {
        toast.error('Pincode already exists!');
      } else {
        toast.error('Fail to add pincode and city!');
      }

      console.error("❌ Error:", message || err.message);
    }

  }


  const handleBulkUpload = async (selectedFile) => {
    try {
      if (!selectedFile) {
        toast.warning("Please upload a valid Excel file");
        return;
      }

      const formData = new FormData();

      formData.append("data_type", "pending");
      formData.append("file", selectedFile);

      const response = await axios.post(
        "https://api.krimotion.in/upload-bulk-pincode-data",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
             Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Data submitted successfully!");

      setFile(null);
      fetchMasterPincode();


    } catch (err) {
      console.error("❌ Error submitting form:", err.response?.data || err.message);
      toast.error("Failed to submit data!");
    }
  };

  const resetForm = () => {
    setFormData({
      state: '',
      city: '',
      pincode: '',
      region: '',
    });

    setIsEditMode(false);
    setEditingCompanyId(null);


  };


  const fetchMasterPincode = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-master-pincode",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;

      setPincode(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchMasterPincode();

  }, []);


  const handleDeletPincode = async () => {
    try {
      const res = await axios.delete(
        `https://api.krimotion.in/delete-master-pincode/${selectedDelete.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Deleted Successfuly!");

      setShowDeleteModal(false);
      setSelectedDelete(null);

      fetchMasterPincode();
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };


  // const filteredData = Array.isArray(pincode)
  //   ? pincode.filter(itm =>
  //     Object.values(itm).some(val =>
  //       String(val).toLowerCase().includes(searchTerm.toLowerCase())
  //     )
  //   )
  //   : [];


    const states = [...new Set(pincode.map(item => item.state))].sort();

const cities = [
  ...new Set(
    pincode
      .filter(item => !selectedState || item.state === selectedState)
      .map(item => item.city)
  )
].sort();


const filteredData = Array.isArray(pincode)
  ? pincode.filter(item => {
      const matchesSearch = Object.values(item).some(value =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      );

      const matchesState =
        !selectedState || item.state === selectedState;

      const matchesCity =
        !selectedCity || item.city === selectedCity;

      return matchesSearch && matchesState && matchesCity;
    })
  : [];



  return (
    <div className="container py-4">
      <div className="border-0  mb-3 px-2 py-2  ">

        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

          {/* LEFT TITLE */}
          <div className="d-flex align-items-center">
            <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
              Manage Master Pincode
            </h4>
          </div>

          {/* CENTER SEARCH */}
          <div style={{ flex: 1, maxWidth: "250px" }}>
            <div
              className="d-flex align-items-center rounded-pill overflow-hidden"
              style={{
                border: "1px solid var(--green)",
                height: "34px",
                paddingLeft: "8px",
                paddingRight: "8px",
                backgroundColor: 'white'
              }}
            >
              {/* ICON */}
              <FaSearch
                style={{
                  color: "var(--green)",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center"
                }}
              />

              {/* INPUT */}
              <input
                type="text"
                className="form-control border-0 shadow-none"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  fontSize: "14px",
                  height: "32px",
                  marginLeft: "6px",
                  lineHeight: "32px"
                }}
              />
            </div>
          </div>

          {/* RIGHT BUTTON */}
          <div className="d-flex align-items-center gap-2">
            {!showForm ? (
              <>
                <button
                  onClick={handleButtonClick}
                  className="btn btn-sm px-3 btn-primary"
                >
                  Upload

                </button>

                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  accept=".xlsx,.xls"
                  style={{ display: "none" }}
                />

                <button
                  className="btn btn-sm px-3 "
                  onClick={() => setShowForm(true)}
                  style={{
                    backgroundColor: "var(--green)",
                    color: "white",
                    fontSize: "13px",
                    height: "34px"
                  }}
                >
                  <FaPlus className="me-1" />
                  Add
                </button>

              </>
            ) : (
              <button
                className="btn btn-danger btn-sm px-3"
                onClick={() => {
                  resetForm();
                  setShowForm(false);
                }}
                style={{ height: "34px", fontSize: "13px" }}
              >
                <FaTimes className="me-1" />
                Close
              </button>
            )}
          </div>

        </div>
      </div>

      <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
    <select
    className="form-select form-select-sm"
    style={{ width: 180 }}
    value={selectedState}
    onChange={(e) => {
      setSelectedState(e.target.value);
      setSelectedCity("");
    }}
  >
    <option value="">All States</option>

    {states.map(state => (
      <option key={state} value={state}>
        {state}
      </option>
    ))}
  </select>

  <select
    className="form-select form-select-sm"
    style={{ width: 180 }}
    value={selectedCity}
    onChange={(e) => setSelectedCity(e.target.value)}
  >
    <option value="">All Cities</option>

    {cities.map(city => (
      <option key={city} value={city}>
        {city}
      </option>
    ))}
  </select> 
</div>


      {showForm && (
        <div className="card shadow-sm border-0 rounded-4 p-3">

          <form onSubmit={handleSubmit}>
            <div className="row g-3">


              <div className="col-md-4">
                <label className="form-label fw-semibold">State</label>
                <div className="input-group">
                  <span className="input-group-text">
                    <FaBoxOpen />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter State"
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>


              <div className="col-md-4">
                <label className="form-label fw-semibold">City</label>
                <div className="input-group">
                  <span className="input-group-text">
                    <FaTags />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter city"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="col-md-4">
                <label className="form-label fw-semibold">Pincode </label>
                <div className="input-group">
                  <span className="input-group-text">
                    <FaMoneyBillWave />
                  </span>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Pincode "
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>



              {/* Save Button */}
              <div className="col-12 text-end">
                <button type="submit" className="btn-action btn-success-custom" style={{ backgroundColor: "var(--green)", color: 'white' }}>
                  {isEditMode ? "Update  " : " Save "}
                </button>
              </div>

            </div>
          </form>
        </div>
      )}

      {/* {!showForm && (
        <>
          <div className="card shadow-lg border-0 rounded-4 mt-3 overflow-hidden " style={{ background: '#f4f6f9' }}>

            <div className="card-body p-3">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0 text-center" >
                  <thead  >
                    <tr>
                      <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}> State</th>
                      <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>City</th>
                      <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Pincode</th>
                      <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((dealer, index) => (
                        <tr key={index}>
                          <td>{dealer.state}</td>
                          <td>{dealer.city}</td>
                          <td>{dealer.pincode}</td>

                          <td>

                            <MdDeleteForever
                              size={26}
                              title="Delete Enquiry"
                              className="text-danger"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedDelete(dealer);
                                setShowDeleteModal(true);
                              }}
                            />
                          </td>


                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center py-4">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>

                </table>
              </div>
            </div>



        
          </div>

        </>
      )} */}

      {!showForm && (
  <div className="container-fluid mt-4">
    <div className="row g-4">

      {filteredData.length > 0 ? (
        filteredData.map((dealer, index) => (

          <div className="col-xl-4 col-lg-6 col-md-6" key={index}>

            <div className="inventory-card d-flex flex-column h-100">

              {/* Header */}
     <div className="d-flex justify-content-between align-items-center mb-3">

  <h5 className="fw-bold mb-0">
    {dealer.city}
  </h5>

  <MdDeleteForever
    size={28}
    title="Delete"
    className="text-danger"
    style={{ cursor: "pointer" }}
    onClick={() => {
      setSelectedDelete(dealer);
      setShowDeleteModal(true);
    }}
  />

</div>
              {/* Details */}

              <div className="inventory-row">
                <span className="inventory-label">
                  State
                </span>
                <span>{dealer.state}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  City
                </span>
                <span>{dealer.city}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Pincode
                </span>
                <span>{dealer.pincode}</span>
              </div>

              {/* Bottom Action */}

              {/* <div className="mt-auto pt-3 text-end">

                <MdDeleteForever
                  size={28}
                  title="Delete"
                  className="text-danger"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedDelete(dealer);
                    setShowDeleteModal(true);
                  }}
                />

              </div> */}

            </div>

          </div>

        ))
      ) : (

        <div className="col-12">
          <div className="text-center py-5">
            No Data Found
          </div>
        </div>

      )}

    </div>
  </div>
)}

          {showDeleteModal && (
              <>
                <div
                  className="modal-backdrop fade show"
                  onClick={() => {
                    setShowDeleteModal(false);
                    setSelectedDelete(null);
                  }}
                ></div>

                <div className="modal fade show d-block">
                  <div className="modal-dialog modal-dialog-centered">
                    <div
                      className="modal-content border-0 shadow-lg"
                      style={{ borderRadius: "16px" }}
                    >

                      <div className="modal-header bg-danger text-white">
                        <h5 className="modal-title fw-bold">
                          🗑 Delete Pincode
                        </h5>

                        <button
                          className="btn-close btn-close-white"
                          onClick={() => setShowDeleteModal(false)}
                        ></button>
                      </div>


                      <div className="modal-body text-center py-4">

                        <div style={{ fontSize: "60px" }}>⚠️</div>

                        <h5 className="mt-3 fw-bold">
                          Are you sure?
                        </h5>

                        <p className="text-muted mb-0">
                          You are about to permanently delete this pincode.
                        </p>

                        <h6 className="fw-bold text-dark mt-2">
                          {selectedDelete?.pincode}
                        </h6>

                        <p className="text-danger fw-semibold mt-2">
                          This action cannot be undone.
                        </p>

                      </div>


                      <div className="modal-footer border-0 justify-content-center">

                        <button
                          className="btn btn-outline-secondary px-4"
                          onClick={() => {
                            setShowDeleteModal(false);
                            setSelectedDelete(null);
                          }}
                        >
                          Cancel
                        </button>

                        <button
                          className="btn btn-danger px-4"
                          onClick={handleDeletPincode}
                        >
                          🗑 Delete
                        </button>

                      </div>

                    </div>
                  </div>
                </div>
              </>
            )}
    </div>
  )
}

export default Pincode
